import { __generator } from "tslib";
import { all, takeEvery } from 'redux-saga/effects';
import { premiumFolderPurchased } from './actions';
function handlePurchase(message) {
    var targetUrl;
    return __generator(this, function (_a) {
        targetUrl = message.payload.targetUrl;
        if (targetUrl) {
            window.location.href = targetUrl;
        }
        else {
            window.location.reload();
        }
        return [2 /*return*/];
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(premiumFolderPurchased, handlePurchase),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map